// extracted by mini-css-extract-plugin
module.exports = {"image-with-background":"Customization_image-with-background__7oCZ_"};